<template>
  <v-card ripple class="list_card">
    <v-card-title primary-title>
      <div style='width:100%;text-align:center;'>
        <h3 class="headline"><v-icon>{{ icon }}</v-icon></h3>
        <p style="font-size:20px">{{ description }}</p>
      </div>
    </v-card-title>
  </v-card>
</template>
<script>
export default {
  name: "AddCard",
  props: {
    icon: {
      type: String,
      default: "add"
    },
    description: {
      type: String,
      default: "New"
    }
  }
}
</script>
